const TEAM_METADATA_CATEGORIES = Object.freeze([
  'Sports Club',
  'Youth Group / Scouts',
  'Music / Performing Arts Group',
  'Community Association',
  'Religious Group',
  'Support Group',
  'Educational Club / Society',
  'Hobby or Social Club',
  'Trade or Professional Association',
  'Volunteering Organisation',
  'Other',
]);

const SPORTS_TYPES = Object.freeze([
  'Football Club',
  'Rugby Club',
  'Cricket Club',
  'Martial Arts',
  'Netball Club',
  'Hockey Club',
  'Swimming Club',
  'Athletics Club',
  'Tennis Club',
  'Badminton Club',
  'Cycling Club',
  'Gymnastics Club',
  'Dance Group',
  'SUP (Stand Up Paddleboarding)',
  'Rowing Club',
  'Sailing Club',
  'Shooting Club',
  'Archery Club',
  'Equestrian Club',
  'Golf Club',
  'Fencing Club',
  'Table Tennis Club',
  'Volleyball Club',
  'Basketball Club',
  'Baseball / Softball Club',
  'Bowls Club',
  'Boxing Club',
  'Canoeing / Kayaking Club',
  'Cheerleading Club',
  'Climbing / Mountaineering Club',
  'Darts Club',
  'Disability / Inclusive Sports Club',
  'Diving Club',
  'Dragon Boat Club',
  'Fishing / Angling Club',
  'Futsal Club',
  'Gaelic Games Club',
  'Handball Club',
  'Ice Hockey Club',
  'Lacrosse Club',
  'Motorsport Club',
  'Multi-Sport Club',
  'Orienteering Club',
  'Pickleball Club',
  'Running / Jogging Club',
  'Skating Club',
  'Skiing / Snow Sports Club',
  'Squash Club',
  'Surfing Club',
  'Triathlon Club',
  'Walking / Hiking Club',
  'Water Polo Club',
  'Weightlifting / Powerlifting Club',
  'Wrestling Club',
  'Yoga / Pilates Group',
  'Other Sport',
]);

const IAM_ROADSMART_TYPE = 'IAM RoadSmart Group';

const TEAM_METADATA_TYPES_BY_CATEGORY = Object.freeze({
  'Sports Club': SPORTS_TYPES,
  'Youth Group / Scouts': Object.freeze([
    'Scout Group',
    'Guide Group',
    'Cadet Unit',
    "Boys' Brigade Group",
    "Girls' Brigade Group",
    'Youth Club',
    'Youth Council / Forum',
    "Duke of Edinburgh's Award Group",
    'Young Farmers Club',
    'After-School Club',
    'Holiday / Play Scheme',
    'Youth Volunteering Group',
    'Faith-Based Youth Group',
    'Other Youth Group',
  ]),
  'Music / Performing Arts Group': Object.freeze([
    'Choir',
    'Orchestra',
    'Brass Band',
    'Concert / Wind Band',
    'Marching Band',
    'Music Ensemble',
    'Theatre / Drama Group',
    'Musical Theatre Group',
    'Amateur Dramatics Society',
    'Performing Arts Group',
    'Opera Group',
    'Film / Media Group',
    'Circus / Acrobatics Group',
    'Puppetry Group',
    'Comedy / Improvisation Group',
    'Other Music / Performing Arts Group',
  ]),
  'Community Association': Object.freeze([
    'Residents Association',
    'Neighbourhood Association',
    'Community Centre',
    'Village Hall Committee',
    'Tenants Association',
    'Cultural Community Group',
    'Heritage / Local History Group',
    'Civic Society',
    'Community Garden Group',
    'Festival / Carnival Committee',
    "Men's Shed",
    "Women's Institute / Community Group",
    'Parent / Community Network',
    'Community Action Group',
    'Local Development Trust',
    'Other Community Group',
  ]),
  'Religious Group': Object.freeze([
    'Church / Christian Congregation',
    'Mosque / Islamic Community',
    'Synagogue / Jewish Community',
    'Hindu Temple / Community',
    'Buddhist Centre / Community',
    'Gurdwara / Sikh Community',
    'Interfaith Group',
    'Faith Study / Prayer Group',
    'Mission / Ministry',
    'Religious Fellowship / Order',
    'Other Faith Group',
  ]),
  'Support Group': Object.freeze([
    'Health Condition Support Group',
    'Mental Health Support Group',
    'Disability Support Group',
    'Carers Support Group',
    'Bereavement Support Group',
    'Addiction / Recovery Group',
    'Peer Support Group',
    'Parent / Family Support Group',
    'Veterans Support Group',
    'LGBTQ+ Support Group',
    'Survivor Support Group',
    'Neurodiversity Support Group',
    'Loneliness / Befriending Group',
    'Welfare / Advice Group',
    'Other Support Group',
  ]),
  'Educational Club / Society': Object.freeze([
    'School Club / Society',
    'College Club / Society',
    'University / Student Society',
    'Student Union / Association',
    'Academic / Learned Society',
    'Debating / Public Speaking Society',
    'Language / Cultural Learning Group',
    'STEM / Coding Club',
    'Literary / Writing Society',
    'Lifelong Learning / U3A Group',
    'Home Education Group',
    'Parent-Teacher Association',
    'Alumni Association',
    IAM_ROADSMART_TYPE,
    'Other Educational Club / Society',
  ]),
  'Hobby or Social Club': Object.freeze([
    'Book Club',
    'Gardening / Allotment Club',
    'Photography Club',
    'Art Club',
    'Craft / Textile Group',
    'Maker / Model Engineering Club',
    'Board Game / Tabletop Club',
    'Video Gaming / Esports Club',
    'Collectors Club',
    'Food / Cookery Club',
    'Wine / Beer Appreciation Club',
    'Travel Club',
    'Friendship / Social Club',
    'Classic Vehicle Club',
    'Genealogy / Family History Group',
    'Astronomy Club',
    'Nature / Birdwatching Club',
    'Walking / Hiking Club',
    'Retirement / Seniors Club',
    IAM_ROADSMART_TYPE,
    'Other Hobby / Social Club',
  ]),
  'Trade or Professional Association': Object.freeze([
    'Professional Body',
    'Trade Association',
    'Chamber of Commerce',
    'Business Networking Group',
    'Trade Union / Staff Association',
    'Guild / Livery Organisation',
    'Industry Forum / Network',
    'Accreditation / Standards Body',
    'Practitioner Network',
    'Employers Association',
    'Co-operative / Federation',
    'Young Professionals Network',
    'Other Trade / Professional Association',
  ]),
  'Volunteering Organisation': Object.freeze([
    'Charity / Fundraising Group',
    'Community Volunteer Group',
    'Conservation / Environmental Group',
    'Animal Rescue / Welfare Group',
    'Search and Rescue Group',
    'Emergency Response Volunteers',
    'Food Bank / Community Pantry',
    'Mutual Aid Group',
    'Befriending Volunteers',
    'Event / Festival Volunteers',
    'Heritage Volunteers',
    'Hospital / Hospice Volunteers',
    'Service Club',
    'International Aid Group',
    'Trustee / Volunteer Network',
    IAM_ROADSMART_TYPE,
    'Other Volunteering Organisation',
  ]),
  Other: Object.freeze([
    'Charity / Non-profit Organisation',
    'Political / Campaign Group',
    'Co-operative',
    'Membership Network',
    'Online Community',
    'Workplace Social Club',
    'Housing Co-operative',
    'Umbrella Group / Federation',
    'Special Interest Group',
    'Private Members Club',
    'Other Club / Organisation',
  ]),
});

const TEAM_METADATA_TYPE_TO_CATEGORIES = Object.freeze(
  Object.entries(TEAM_METADATA_TYPES_BY_CATEGORY).reduce((acc, [category, types]) => {
    types.forEach((type) => {
      acc[type] = Object.freeze([...(acc[type] || []), category]);
    });
    return acc;
  }, {})
);

// Retained for callers that need one deterministic fallback parent.
const TEAM_METADATA_TYPE_TO_CATEGORY = Object.freeze(
  Object.fromEntries(
    Object.entries(TEAM_METADATA_TYPE_TO_CATEGORIES)
      .map(([type, categories]) => [type, categories[0]])
  )
);

function categoriesForType(type) {
  return TEAM_METADATA_TYPE_TO_CATEGORIES[normalizeString(type)] || [];
}

const BESPOKE_MODULE_GROUPS = Object.freeze([
  {
    key: 'iamRoadSmart',
    title: 'IAM RoadSmart Modules',
    requiredLabels: [IAM_ROADSMART_TYPE],
  },
  {
    key: 'rowing',
    title: 'Rowing Modules',
    requiredLabels: ['Rowing Club'],
  },
  {
    key: 'sailing',
    title: 'Sailing Modules',
    requiredLabels: ['Sailing Club'],
  },
]);

function normalizeString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function uniqueStrings(values = []) {
  return Array.from(
    new Set(
      values
        .map(normalizeString)
        .filter(Boolean)
    )
  );
}

function inferFromLegacySector(sector) {
  const normalizedSector = normalizeString(sector);
  if (!normalizedSector) {
    return {
      categories: [],
      types: [],
      primaryCategory: '',
      primaryType: '',
    };
  }

  const inferredCategory = categoriesForType(normalizedSector)[0];
  if (inferredCategory) {
    return {
      categories: [inferredCategory],
      types: [normalizedSector],
      primaryCategory: inferredCategory,
      primaryType: normalizedSector,
    };
  }

  return {
    categories: [normalizedSector],
    types: [],
    primaryCategory: normalizedSector,
    primaryType: '',
  };
}

function ensureCategoryForTypes(categories = [], types = []) {
  const nextCategories = [...categories];
  types.forEach((type) => {
    const parentCategories = categoriesForType(type);
    const alreadyHasParent = parentCategories.some((category) => nextCategories.includes(category));
    if (!alreadyHasParent && parentCategories[0]) nextCategories.push(parentCategories[0]);
  });
  return nextCategories;
}

function normalizePrimaryCategory(primaryCategory, categories, primaryType) {
  const normalizedPrimaryCategory = normalizeString(primaryCategory);
  if (normalizedPrimaryCategory && categories.includes(normalizedPrimaryCategory)) {
    return normalizedPrimaryCategory;
  }

  const inferredFromType = categoriesForType(primaryType)
    .find((category) => categories.includes(category));
  if (inferredFromType) return inferredFromType;
  return categories[0] || '';
}

function normalizePrimaryType(primaryType, types) {
  const normalizedPrimaryType = normalizeString(primaryType);
  if (normalizedPrimaryType && types.includes(normalizedPrimaryType)) {
    return normalizedPrimaryType;
  }
  return types[0] || '';
}

export function hasModernTeamMetadataShape(metadata = {}) {
  const rawCategories = uniqueStrings(Array.isArray(metadata?.categories) ? metadata.categories : []);
  const rawTypes = uniqueStrings(Array.isArray(metadata?.types) ? metadata.types : []);
  const rawPrimaryCategory = normalizeString(metadata?.primaryCategory);
  const rawPrimaryType = normalizeString(metadata?.primaryType);
  return rawCategories.length > 0
    || rawTypes.length > 0
    || rawPrimaryCategory !== ''
    || rawPrimaryType !== '';
}

export function isLegacyTeamMetadata(metadata = {}) {
  if (hasModernTeamMetadataShape(metadata)) return false;
  return normalizeString(metadata?.sector) !== '';
}

export function normalizeTeamMetadata(metadata = {}) {
  const legacySector = normalizeString(metadata?.sector);
  const rawCategories = uniqueStrings(Array.isArray(metadata?.categories) ? metadata.categories : []);
  const rawTypes = uniqueStrings(Array.isArray(metadata?.types) ? metadata.types : []);
  const rawPrimaryCategory = normalizeString(metadata?.primaryCategory);
  const rawPrimaryType = normalizeString(metadata?.primaryType);

  const hasModernShape = hasModernTeamMetadataShape(metadata);

  const source = hasModernShape
    ? {
      categories: rawCategories,
      types: rawTypes,
      primaryCategory: rawPrimaryCategory,
      primaryType: rawPrimaryType,
    }
    : inferFromLegacySector(legacySector);

  const types = uniqueStrings(source.types);
  const categories = uniqueStrings(ensureCategoryForTypes(source.categories, types));
  const hasExplicitPrimary = source.primaryCategory !== '' || source.primaryType !== '';
  const primaryType = hasExplicitPrimary
    ? (normalizeString(source.primaryType) && types.includes(normalizeString(source.primaryType))
      ? normalizeString(source.primaryType)
      : '')
    : normalizePrimaryType(source.primaryType, types);
  const primaryCategory = normalizePrimaryCategory(source.primaryCategory, categories, primaryType);
  const labels = uniqueStrings([...categories, ...types]);
  const primaryLabel = primaryType || primaryCategory || legacySector || '';

  return {
    categories,
    types,
    primaryCategory,
    primaryType,
    primaryLabel,
    labels,
    sector: primaryLabel,
    legacySector,
  };
}

export function teamHasMetadataLabel(metadata = {}, label = '') {
  const targetLabel = normalizeString(label);
  if (!targetLabel) return false;
  return normalizeTeamMetadata(metadata).labels.includes(targetLabel);
}

export function teamMatchesMetadataLabel(metadata = {}, label = '') {
  const targetLabel = normalizeString(label);
  if (!targetLabel) return true;
  return teamHasMetadataLabel(metadata, targetLabel);
}

export function getEligibleBespokeModuleGroups(metadata = {}) {
  return BESPOKE_MODULE_GROUPS.filter((group) =>
    group.requiredLabels.some((label) => teamHasMetadataLabel(metadata, label))
  );
}

export function getBespokeModuleSupport(metadata = {}) {
  const eligibleKeys = new Set(
    getEligibleBespokeModuleGroups(metadata).map((group) => group.key)
  );
  return {
    iamRoadSmart: eligibleKeys.has('iamRoadSmart'),
    rowing: eligibleKeys.has('rowing'),
    sailing: eligibleKeys.has('sailing'),
  };
}

export {
  TEAM_METADATA_CATEGORIES,
  TEAM_METADATA_TYPES_BY_CATEGORY,
  TEAM_METADATA_TYPE_TO_CATEGORIES,
  TEAM_METADATA_TYPE_TO_CATEGORY,
  BESPOKE_MODULE_GROUPS,
};
